import { ContentCopy as ContentCopyIcon } from '@mui/icons-material';
import { Button as MuiButton } from '@mui/material';
import { QRCodeSVG } from 'qrcode.react';
import { useRef } from 'react';
import { Button, FunctionField, SimpleShowLayout, useNotify, useRecordContext } from 'react-admin';

const containerLinkFieldSx = {
  display: 'flex',
  padding: 0,
  alignItems: 'center',
  justifyContent: 'center',
  marginTop: '12px',
};

const LinkField = ({ url }: any) => {
  const notify = useNotify();

  const handleClipboard = () => {
    if (url) {
      navigator.clipboard.writeText(url);
      notify("Link copiado para clipboard", { type: "info", autoHideDuration: 1000 });
    }
  }

  return (
    <SimpleShowLayout sx={containerLinkFieldSx}>
      <MuiButton onClick={handleClipboard} size="small" variant="outlined" sx={{ marginTop: "20px", marginRight: "10px" }}>
        <ContentCopyIcon sx={{ fontSize: 18 }} />
      </MuiButton>
      <FunctionField label="Link" render={() => url} />
    </SimpleShowLayout>
  );
}

const AppDownloadQRCode = () => {
  const record = useRecordContext();
  const svgRef = useRef(null);
  if (!record) { return null; }

  const url = `https://${record.code}-app.pontuax.com.br/download`;

  const downloadBlob = (blob: Blob, filename: string) => {
    const objectUrl = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = objectUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const downloadSvg = () => {
    //@ts-ignore
    const content = svgRef.current?.children[0].innerHTML;
    const contentWithSvg = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" viewBox="0 0 29 29" width="600" height="600">
      ${content.replace(/fill="#ffffff"/g, 'fill="none"')}
      </svg>`;
    const blob = new Blob([contentWithSvg], { type: "image/svg+xml" });
    downloadBlob(blob, `qr-code-${record.name}`);
  };

  return (
    <div style={{ textAlign: "center", marginBottom: 8 }}>
      <div ref={svgRef}>
        <QRCodeSVG
          value={url}
          bgColor="#ffffff"
          fgColor="#000000"
          size={256}
        />
      </div>
      <Button color="primary" style={{ marginTop: 8 }} size="medium" label="Baixar SVG" onClick={downloadSvg} variant="outlined" />
      <LinkField url={url} />
    </div>
  );
}

export default AppDownloadQRCode;
